import React, { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';

interface IProps {
  [id: string]: string | undefined;
}

export const useVariableTabState = (routeName: string): [number[], React.Dispatch<React.SetStateAction<number[]>>] => {
  const match = useRouteMatch<IProps>(`${routeName}/v/:id`);
  const id = Number(match?.params?.id);
  const initialIds = id ? [id] : [];

  return useState<number[]>(initialIds);
};
